import React from "react";
import axios from 'axios';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {DropzoneArea} from 'material-ui-dropzone'
 
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

import Link from '@material-ui/core/Link';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import LinearProgress from '@material-ui/core/LinearProgress';

import NumberFormat from 'react-number-format';

import  api from '../common/api';


class ContractsForm extends React.Component {

	constructor() {
		super();
		this.state = {
			contracts:
		 	{
		 		id:'',
				name: '',
				hansa_cu_num: '',
				hansa_ID:'',
				hansa_start_date: '',
				hansa_end_date: '',
				contract_type_id: '',
				contract_origin_id:'',
			    client_approval_username: '',
			    client_approval_date: '',
			    client_estimated_fleet:'',
			    client_first_limit:'',
			    client_second_limit:'',
			    autocorp_approval_username: '',
			    autocorp_approval_date: '',
			    autocorp_commercial_username:'',
			    autocorp_implementation_username: '',
			    autocorp_post_sale_username: '',
			    comments: '',
			    contact_id:'',
				disabled: false,
				files:[],
			},
			contacts:[],
			clients:[],
			errors:{
				hansa_start_date:'',
				hansa_end_date:'',
				client_first_limit:'',
				client_second_limit:'',
			},
			contractOrigins:[],
			contractTypes:[], 
			usernames:[], 
			media:[],
			loading: true,

		}
	}

	async componentDidMount() {
//		await this.getContacts();	
		await this.getClients();
		await this.getUsernames();
		await this.getParams();
		await this.getContractsOrigins();
		await this.getContractTypes();
    	this.setState({loading: false})
	}
	
	getParams = async (location) => {
    	const action = window.location.pathname.split("/").pop();
	    const searchParams = new URLSearchParams(window.location.search);
    	const idContract=searchParams.get('id')
    	if (action === 'new'){
    		this.setState({action: action})
    		this.setState({disabled: false})
    	} else if (action === 'edit') {
    		this.setState({action: action})
    		this.setState({disabled: false})
    	} else if (action === 'view'){
    		this.setState({action: action})
    		this.setState({disabled: true})
    	}
		await this.setContract(idContract);
		let clientIdx =''
		let clientApprovalId =''
		if (this.state.contracts.contact_id !=='' && this.state.contracts.contact_id !== null){
			clientIdx = await this.getContactsByName(this.state.contracts.contact_id)
		}
/*		if (this.state.contracts.client_approval_username !='' && this.state.contracts.client_approval_username != null){
    		clientApprovalId = await this.getContactsByName(this.state.contracts.client_approval_username)
		}
*/
		this.setState({clientId: clientIdx})
		this.setState({clientApprovalId: clientApprovalId})

    }

    getContactsByName = (id) =>{
    	var tmp_idx = -1;
    	this.state.clients.map((val, idx)=>{
    		if (val.contact){
	    		if (val.contact.id  === id){
	    			tmp_idx = idx;
	    		}
    		}
    	})
		return tmp_idx;

    }

    async getUsernames(){
    	const token = localStorage.getItem('userToken')

    	return await axios
	     .get(api.usernames,{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({usernames: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    async getContractTypes(){
    	const token = localStorage.getItem('userToken')

    	return await axios
	     .get(api.contractTypes,{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({contractTypes: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    async getContractsOrigins(){
    	const token =localStorage.getItem('userToken')

    	return await axios
	     .get(api.contractOrigins,{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({contractOrigins: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    async getContacts(){
    	const token =localStorage.getItem('userToken')

		return axios
	     .get(api.hansa_contacts,{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({contacts: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    async getClients(){
    	const token = localStorage.getItem('userToken')

		return axios
	     .get(api.clients().all(1),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({clients: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })
    }

    setContract(idContract){
    	const token = localStorage.getItem('userToken')

	    return axios
	         .get(api.contract().get(idContract),{ headers: {"Authorization" : `Bearer ${token}`} })
	          .then(res => {
	          	  if (res.data[0].client_first_limit === null){
	          	  	res.data[0].client_first_limit=0;
	          	  }
	          	  if (res.data[0].client_second_limit === null){
	          	  	res.data[0].client_second_limit=0;
	          	  }
				  this.setState({contracts: res.data[0]})
				  this.setState({media: res.data[0].media})
	              return res.data
	          })
	          .catch(err =>{console.log(err)
	          })
    }

	formatDate(date){
		//hansa_start_date = '2019-12-31'
		    	//return newDate[2]
		if (date == null ) {
			return null
		} else {
			let fromDate = new Date(date)	
			let year = fromDate.getFullYear();
			let month = fromDate.getMonth() + 1
			month = month < 10 ? '0' + month: month
			let day =  fromDate.getDate() < 10 ? '0'+ fromDate.getDate(): fromDate.getDate()
			//return fromDate.getFullYear() + "-" + (fromDate.getMonth()+1) + "-" + fromDate.getDate();

			return year+'-'+month+'-'+day
		}
	}

	handleChangeForm = (e) => {
 		let contractsCopy = JSON.parse(JSON.stringify(this.state.contracts))
 		if (e.target.name ==='client_first_limit' || e.target.name === 'client_second_limit'){
 			contractsCopy[e.target.name] = e.target.value.replace('$','').replace(/\./g,'')
 		} else {
	        contractsCopy[e.target.name] = e.target.value
 		}
        this.setState({ contracts: contractsCopy})
        this.handleValidations(contractsCopy);
	}

	handleValidations(contracts){
 		let errorsCopy = {}
		if(contracts.hansa_end_date !== ''  && contracts.hansa_start_date > contracts.hansa_end_date){
			errorsCopy['hansa_end_date'] = 'La fecha hasta debe ser mayor que la fecha desde';
		} else {
			errorsCopy['hansa_end_date'] = '';
			errorsCopy['hansa_start_date'] = '';
		}
		errorsCopy['client_first_limit'] = ''
		if(contracts.client_second_limit !== 0){
			if (parseInt(contracts.client_first_limit.toString().replace(/\./g,'')) > parseInt(contracts.client_second_limit.toString().replace(/\./g,''))){
				errorsCopy['client_first_limit'] = 'El primer límite debe ser menor que el segundo';
			} else if (contracts.client_first_limit === '' ){
				errorsCopy['client_first_limit'] = 'Debe completar el primer límite de crédito';
			}
		}
        this.setState({ errors: errorsCopy})
	}

	handleRedirect(){
		window.location.href="/contracts"
	}

	handleUpload(files){
	    this.setState({
	      files: files
	    });
	}

	handleAutocomplete =(event, values) => {
	    var res = event.target.id.split("-");
	    const section = res[0];
	    const varName =res[1];
		let contractsCopy = JSON.parse(JSON.stringify(this.state.contracts))
		if (values){
	        contractsCopy[section] = values.contact_id
		} else {
	        contractsCopy[section] = ''
		}
        this.setState({ contracts: contractsCopy})

    }	
	
	handleSubmit = (e) => {
		e.preventDefault()

		var formData = new FormData();
		var item = this.state.contracts

		if  (this.state.errors.client_first_limit !== '' || this.state.errors.hansa_start_date !=='' || this.state.errors.hansa_end_date !==''){
			alert('Hay valores erroneos. Por favor revisar')
			return;
		}

		for ( var key in item ) {
			if (typeof item[key] !== undefined && item[key] !== null){
		    	formData.set("contract["+key+"]", item[key]);
			}
		}

		if (this.state.files){
		    this.state.files.map((val, idx) => {
	    	  formData.set(`media[${idx}]`, val)
		    })
		}

		let self = this
		const token =localStorage.getItem('userToken')

		if (this.state.action ==='new'){
		    axios.post(api.contracts,
		       formData,
		       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
		       )
		      .then((response)=> {
                self.setState({errors: false})
	            self.setState({message: 'Contrato creado con éxito!'})
    	        self.setState({dialogOpen: true})
		      })
		      .catch(function (error) {
                self.setState({errors: true})
	            self.setState({message: 'Hubo un problema al guardar el contrato. Por favor volver a intentar'})
    	        self.setState({dialogOpen: true})
		    })
		  } else {
		  	formData.append('_method', 'patch');
		    axios.post(api.contract().get(this.state.contracts.id),
		       formData,
		       {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
		       )
		      .then((response)=> {
                self.setState({errors: false})
	            self.setState({message: 'Contrato modificado con éxito!'})
    	        self.setState({dialogOpen: true})
		      })
		      .catch(function (error) {
               self.setState({errors: true})
	            self.setState({message: 'Hubo un problema al guardar el contrato. Por favor volver a intentar'})
    	        self.setState({dialogOpen: true})
		    })

		  }

	}

	render(){
		const handleDownload = id => () => {
	        console.log(id)
        }
		const handleRedirect = id => () =>{
			window.location.href=`/contracts`
		}

		const handleDialogClose = () => {
			this.setState({dialogOpen: false})
		}        

		let {
			name,
			hansa_start_date,
			hansa_end_date,
			contract_type_id,
			contract_origin_id,
		    client_approval_username,
		    client_approval_date,
		    client_estimated_fleet,
		    client_first_limit,
		    client_second_limit,
		    autocorp_approval_username,
		    autocorp_approval_date,
		    autocorp_commercial_username,
		    autocorp_implementation_username,
		    autocorp_post_sale_username,
		    hansa_service_num,
		    hansa_ID, 
		    comments
			} = this.state.contracts

		let errors = this.state.errors
		
		let media = this.state.media
		return (
          (this.state.loading)?
           <LinearProgress /> 
            :
	        <form onSubmit={this.handleSubmit} onChange={this.handleChangeForm} >
		          <Dialog
		            open={this.state.dialogOpen}
		            fullWidth
		            aria-labelledby="responsive-dialog-title"
		          >
		            <DialogTitle id="responsive-dialog-title">{"Contrato"}</DialogTitle>
		            <DialogContent>
		              <DialogContentText>
		                  {this.state.message}
		              </DialogContentText>
		            </DialogContent>
		            <DialogActions disableSpacing="false">  
		              {(this.state.errors) ?
		                <Button onClick={handleDialogClose} variant="contained" color="primary" >
		                    Aceptar
		                </Button>
		                :
		                <Button onClick={handleRedirect(this.state.contract_id)} variant="contained" color="primary" >
		                    Aceptar
		                </Button>
		               }
		            </DialogActions>
		          </Dialog>


				  <Autocomplete
					disabled={this.state.disabled}
				  	options={this.state.clients}
					getOptionLabel={option => option.business_name}
					id="contact_id"
					defaultValue={this.state.clients[this.state.clientId]}
					onChange={this.handleAutocomplete}
				    autoComplete
					noOptionsText="Sin resultados"
					name="contact_id"
				    includeInputInList
					className="mr-4 mt-1"
					style={{ fontSize: '0.75rem', width: 500 }}
				    renderInput={params => (
				      <TextField {...params}
			       			margin="normal"
							label="Cliente"
							required
							InputLabelProps={{ ...params.InputLabelProps,
												shrink: true
							}}
							inputProps={{
							            ...params.inputProps,
							            style:{fontSize: '0.75rem', width: 200}
							          }}

						/>
				    )}
				  />
					{(hansa_ID) 
					?
						<TextField
						disabled={true}
						id="hansa_ID"
						label="Código de hansa"
						type="text"
						name="hansa_ID"
						value={hansa_ID}
						className="mr-2"
						InputLabelProps={{
						  shrink: true,
						}}
						inputProps={{style:{fontSize: '0.75rem'}}} 
						/>	
					:
					''
					}		          

				 <TextField
				  id="name"
				  placeholder="Ingrese un nombre de contrato"
				  required
				  label="Nombre del contrato"
		          disabled={this.state.disabled}
				  name="name"
				  value={name}
				  margin="normal"
				  className="mr-2 mt-0"
				  InputLabelProps={{
				    shrink: true
				  }}
				  inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
				/>
				<FormControl className="mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='contract_type_id' >
				  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Tipo de contrato</InputLabel>
				  <Select native name='contract_type_id'
				  required
		          disabled={this.state.disabled}
				   inputProps={{
				        name:"contract_type_id",
				        className:"contract_type_id"
				      }}
				      style={{minWidth: 150, fontSize: '0.75rem'}}
				    value={contract_type_id}
				    input={<Input id="grouped-native-select" name='contract_type_id'/>}>
				    <option value="" />
						{this.state.contractTypes.map((contractType) => <option id={contractType.id} value={contractType.id}>{contractType.name}
					</option>)}
				  </Select>
				</FormControl>
				<FormControl className="mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='contract_origin_id' >
				  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Origen del contrato</InputLabel>
				  <Select native name='contract_origin_id'
		          disabled={this.state.disabled}
		          required
				   inputProps={{
				        name:"contract_origin_id",
				        className:"contract_origin_id"
				      }}
				      style={{minWidth: 150, fontSize: '0.75rem'}}
				    value={contract_origin_id}
				    input={<Input id="grouped-native-select" name='contract_origin_id	'/>}>
				    <option value="" />                   
						{this.state.contractOrigins.map((contractOrigin) => <option id={contractOrigin.id} value={contractOrigin.id}>{contractOrigin.name}</option>)}
				  </Select>
				</FormControl>   					   	
				<TextField
				error= {(this.state.errors.hansa_start_date)?true: false}
				helperText={(this.state.errors.hansa_start_date)?this.state.errors.hansa_start_date: ''}
				disabled={this.state.disabled}
				id="hansa_start_date"
				required
				label="Fecha de inicio"
				type="date"
				name="hansa_start_date"
				value={hansa_start_date}
				className="mr-2"
				InputLabelProps={{
				  shrink: true,
				}}
				inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
				/>				
				<TextField
				error= {(this.state.errors.hansa_end_date)?true: false}
				helperText={(this.state.errors.hansa_end_date)?this.state.errors.hansa_end_date: ''}
				disabled={this.state.disabled}
				name="hansa_end_date"
				id="hansa_end_date"
				label="Fecha de fin"
				className="mr-2"
				type="date"
				value={hansa_end_date}
				InputLabelProps={{
				  shrink: true,
				}}
				inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
				/>
				<Typography gutterBottom variant="h6" className="mt-2 mb-2">
					Datos del cliente
				</Typography>

				<NumberFormat 
							error= {(this.state.errors.client_first_limit) ? true : false}
							helperText={(this.state.errors.client_first_limit) ? this.state.errors.client_first_limit: ''}
							placeholder="Primer limite de crédito"
							required
							label="Primer limite de crédito"
							name="client_first_limit"
				            disabled={this.state.disabled}
				            className="mt-3 mr-2"
							InputProps={{style: {minWidth: 200,fontSize: '0.75rem'}}}
							value={client_first_limit}
				            thousandSeparator='.'
				            decimalSeparator=','
				            prefix={'$'}
				            customInput={TextField}  
				            InputLabelProps={{
				              shrink: true,
				            }}

				/>

				<NumberFormat 
							error= {(this.state.errors.client_second_limit) ? true: false}
							helperText={(this.state.errors.client_second_limit) ? this.state.errors.client_second_limit : ''}
							placeholder="Segundo limite de crédito"
							label="Segundo limite de crédito"
							name="client_second_limit"
				            disabled={this.state.disabled}
				            className="mt-3 mr-2"
							InputProps={{style: {minWidth: 200,fontSize: '0.75rem'}}}
							value={client_second_limit}
				            thousandSeparator='.'
				            decimalSeparator=','
				            prefix={'$'}
				            customInput={TextField}  
				            InputLabelProps={{
				              shrink: true,
				            }}

				/>

				<TextField
				  disabled={this.state.disabled}
				  placeholder="Flota estimada del cliente"
				  label="Flota estimada del cliente"
				  name="client_estimated_fleet"
				  type="number"
				  className="mr-2"
				  InputLabelProps={{
				    shrink: true,
				  }}
				  InputProps={{style: {minWidth: 200, fontSize: '0.75rem'}}}
				  inputProps={{
				    min: 1,
				  }}
				  value={client_estimated_fleet}
				  margin="normal"
				/>				
				<Typography gutterBottom variant="h6" className="mt-2 mb-2">
					Datos de aprobación de cliente
				</Typography>
				<TextField
				  disabled={this.state.disabled}
				  id="client_approval_username"
				  placeholder="Ingrese el usuario aprobador"
	  			  label="Usuario aprobador"
				  name="client_approval_username"
				  value={client_approval_username}
				  margin="normal"
				  className="mr-2"
				  InputLabelProps={{
				    shrink: true
				  }}
				  inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
				/>
				{/* 
				  <Autocomplete
					disabled={this.state.disabled}
				  	options={this.state.contacts}
					getOptionLabel={option => option.hansa_name}
					id="client_approval_username"
					defaultValue={this.state.contacts[this.state.clientApprovalId]}
					onChange={this.handleAutocomplete}
				    autoComplete
					required
					noOptionsText="Sin resultados"
					name="client_approval_username"
				    includeInputInList
					className="mr-4 mt-3"
					style={{ fontSize: '0.75rem', width: 500,display: 'inline' }}
				    renderInput={params => (
				      <TextField {...params}
				       		placeholder="Buscar contacto"
			       			margin="normal"
							label="Usuario aprobador"
							InputLabelProps={{ ...params.InputLabelProps,
												shrink: true
							}}
							inputProps={{
							            ...params.inputProps,
							            style:{fontSize: '0.75rem', width: 200}
							          }}

						/>
				    )}
				  />
				*/}
				<TextField
	     			disabled={this.state.disabled}
					id="client_approval_date"
					name="client_approval_date"
					label="Fecha de aprobación"
					type="date"
					className="mr-2 mt-3"
					value={client_approval_date}
					InputLabelProps={{
					  shrink: true,
					}}
					inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
				/>				
				<Typography gutterBottom variant="h6">
					Datos de aprobación de AutoCorp
				</Typography>
				<FormControl className="mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='autocorp_approval_username' >
				  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Usuario aprobador</InputLabel>
				  <Select native name='autocorp_approval_username'
				  required
		          disabled={this.state.disabled}
				   inputProps={{
				        name:"autocorp_approval_username",
				        className:"autocorp_approval_username"
				      }}
				      style={{minWidth: 150, fontSize: '0.75rem'}}
				    value={autocorp_approval_username}
				    input={<Input id="grouped-native-select" name='autocorp_approval_username'/>}>
				    <option value="" />
						{this.state.usernames.map((username) => <option id={username.name} value={username.name}>{username.name}
					</option>)}
				  </Select>
				</FormControl>


{/*				<TextField
				  disabled={this.state.disabled}
				  id="autocorp_approval_username"
				  placeholder="Ingrese el usuario aprobador"
	  			  label="Usuario aprobador"
				  name="autocorp_approval_username"
				  value={autocorp_approval_username}
				  margin="normal"
				  className="mr-2"
				  InputLabelProps={{
				    shrink: true
				  }}
				  inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
				/>
				<TextField
   				    disabled={this.state.disabled}
					id="autocorp_approval_date"
					name="autocorp_approval_date"
					label="Fecha de aprobación"
					type="date"
					className="mr-2 mt-3"
					value={autocorp_approval_date}
					InputLabelProps={{
					  shrink: true,
					}}
					inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
				/>	
*/}			
				<Typography variant="subtitle1">
					Datos comerciales
				</Typography>
				<FormControl className="mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='autocorp_commercial_username' >
				  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Asesor comercial</InputLabel>
				  <Select native name='autocorp_commercial_username'
				  required
		          disabled={this.state.disabled}
				   inputProps={{
				        name:"autocorp_commercial_username",
				        className:"autocorp_commercial_username"
				      }}
				      style={{minWidth: 150, fontSize: '0.75rem'}}
				    value={autocorp_commercial_username}
				    input={<Input id="grouped-native-select" name='autocorp_commercial_username'/>}>
				    <option value="" />
						{this.state.usernames.map((username) => <option id={username.name} value={username.name}>{username.name}
					</option>)}
				  </Select>
				</FormControl>

				<FormControl className="mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='autocorp_implementation_username' >
				  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Usuario implementador</InputLabel>
				  <Select native name='autocorp_implementation_username'
				  required
		          disabled={this.state.disabled}
				   inputProps={{
				        name:"autocorp_implementation_username",
				        className:"autocorp_implementation_username"
				      }}
				      style={{minWidth: 150, fontSize: '0.75rem'}}
				    value={autocorp_implementation_username}
				    input={<Input id="grouped-native-select" name='autocorp_implementation_username'/>}>
				    <option value="" />
						{this.state.usernames.map((username) => <option id={username.name} value={username.name}>{username.name}
					</option>)}
				  </Select>
				</FormControl>

				<FormControl className="mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='autocorp_post_sale_username' >
				  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 150, fontSize: '0.75rem'}} >Usuario post venta</InputLabel>
				  <Select native name='autocorp_post_sale_username'
				  required
		          disabled={this.state.disabled}
				   inputProps={{
				        name:"autocorp_post_sale_username",
				        className:"autocorp_post_sale_username"
				      }}
				      style={{minWidth: 150, fontSize: '0.75rem'}}
				    value={autocorp_post_sale_username}
				    input={<Input id="grouped-native-select" name='autocorp_post_sale_username'/>}>
				    <option value="" />
						{this.state.usernames.map((username) => <option id={username.name} value={username.name}>{username.name}
					</option>)}
				  </Select>
				</FormControl>

{/*				
				<TextField
				  disabled={this.state.disabled}
				  id="autocorp_commercial_username"
				  placeholder="Ingrese el asesor comercial"
	  			  label="Usuario comercial"
				  name="autocorp_commercial_username"
				  value={autocorp_commercial_username}
				  margin="normal"
				  className="mr-2"
				  InputLabelProps={{
				    shrink: true
				  }}
				  inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
				/>
				<TextField
				  disabled={this.state.disabled}
				  id="autocorp_implementation_username"
				  placeholder="Ingrese el usuario implementador"
	  			  label="Usuario implementador"
				  name="autocorp_implementation_username"
				  value={autocorp_implementation_username}
				  margin="normal"
				  className="mr-2"
				  InputLabelProps={{
				    shrink: true
				  }}
				  inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
				/>
				<TextField
				  disabled={this.state.disabled}
				  id="autocorp_post_sale_username"
				  placeholder="Ingrese el usuario de post venta"
				  name="autocorp_post_sale_username"
	  			  label="Usuario postventa"
				  value={autocorp_post_sale_username}
				  margin="normal"
				  className="mr-2"
				  InputLabelProps={{
				    shrink: true
				  }}
				  inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
				/>
*/}
		        <TextField
				  disabled={this.state.disabled}
		          id="comments"
		          placeholder="Ingrese observaciones"
		          fullWidth
		          value={comments}
		          name="comments"
		          margin="normal"
		          InputLabelProps={{
		            shrink: true,
		          }}
				  inputProps={{style:{fontSize: '0.75rem'}}} 
		        />
		        {(this.state.disabled===false)? (

				<div style={{width: "30rem"}}>
					<DropzoneArea onChange={this.handleUpload.bind(this)} 
						dropzoneText="Arrastra los archivos aquí o buscalos"
						showPreviews="true"
						showPreviewsInDropzone={false}
						showFileNamesInPreview="true"
						showFileNames="true"

					/>
				</div>
				):''}
		        <div className="row"></div>
		        {(media.length>0)?(
		        <Table aria-label="simple table">
		            <TableHead>
		              <TableRow>
		                <TableCell>Nombre del archivo</TableCell>
		                <TableCell></TableCell>
		              </TableRow>
		            </TableHead>
		            <TableBody>
		              {media.map((val,idx) => (
		                <TableRow key={val.id}>
		                  <TableCell>{val.name}</TableCell>
		                  <TableCell>
		                  <Link href={api.media_download+'/'+val.id}><ArrowDownwardIcon />Descargar</Link>
		          </TableCell>
		                </TableRow>
		              ))}
		            </TableBody>
		          </Table>
		            ):''
		          }

				{(this.state.action !== 'view') ? (
			         <Button type="submit" variant="contained" className="mt-3 ml-1 mr-1"  color="primary">
			          Guardar
			        </Button>
			        ): ''
			        }
			      
			        {(this.state.action !== 'view') ? (
			        <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
			          Cancelar
			        </Button>

			          ):
			        <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
			          Volver
			        </Button>

		        }
	        </form>



		)

	}

}
export default ContractsForm;